import React from "react";
import Header from "../../layout/Header/Header";
import Footer from "../../layout/Footer/Footer";
import MostrarOptimo from "../Mostrar/MostrarOptimo";
import imagenes from "../../assets/Imagenes";
import "../../styles/index.css"
import WhatsAppButton from "../../components/BtnWhatsapp/Whatsapp";
const Campo = () => {
	return (
		<>
			<Header />
			<section className="section-todas-pesnias">
			<img src={imagenes.op7} className="banner-todas-pestanias" alt="" />
			</section>
			<h1 className="titulo-h1">Campos</h1>
			<MostrarOptimo tipo="campos" />
			<Footer />
		</>
	);
};

export default Campo;
